import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { checklistInterface } from 'src/app/util/interfaces/checklist';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ChecklistExecutionService } from './service/checklist-execution.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { DateService } from 'src/app/services/date/date.service';
import { AppModule } from 'src/app/app.module';
import { DotBounceLoadingEffectModule } from '../../../page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-checklist-execution',
	standalone: true,
	imports: [CommonModule, RouterModule, FontAwesomeModule, DotBounceLoadingEffectModule],
	templateUrl: './checklist-execution.component.html',
	styleUrl: './checklist-execution.component.css',
})
export class ChecklistExecutionComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_checklist: '',
	};

	constructor(
		private LabelsService: LabelsService,
		private ActivatedRoute: ActivatedRoute,
		private Router: Router,
		private ChecklistExecutionService: ChecklistExecutionService,
		protected DateService: DateService
	) {}

	isLoadingLabels = true;
	isLoadingChecklistData = true;
	isLoadingFail = false;
	isLoadingSuccess = false;

	checklist: checklistInterface;
	currentStepIndex: number;
	currentStep: checklistInterface['steps'][number];
	lastFailIndex: number;
	lastFailStep: checklistInterface['steps'][number];

	ngOnInit(): void {
		this.LabelsService.getLabels()
			.subscribe({
				next: (labels) => {
					this.labels = labels;
				},
			})
			.add(() => {
				this.isLoadingLabels = false;
			});

		this.ActivatedRoute.params.subscribe({
			next: (parameters) => {
				if (!parameters || !parameters.idChecklist) this.Router.navigate([`/checklist`]);

				this.ChecklistExecutionService.getChecklistData(parameters.idChecklist)
					.subscribe({
						next: (checklist) => {
							this.checklist = checklist;
							this.setCurrentStepAndFailStep();
						},
					})
					.add(() => {
						this.isLoadingChecklistData = false;
					});
			},
		});

		this.finishLoading();
	}

	async finishLoading() {
		await this.until(() => this.isLoadingLabels == false && this.isLoadingChecklistData == false);
	}

	until(conditionFunction: Function) {
		const poll = (resolve) => {
			if (conditionFunction()) resolve();
			else setTimeout(() => poll(resolve), 400);
		};

		return new Promise(poll);
	}

	stepFail(): void {
		if (this.isLoadingFail == true || this.isLoadingSuccess == true) return;

		this.isLoadingFail = true;
		this.ChecklistExecutionService.stepFail(this.checklist.id)
			.subscribe({
				next: (checklist) => {
					this.checklist = undefined;
					this.currentStep = undefined;
					this.currentStepIndex = undefined;
					setTimeout(() => {
						this.checklist = checklist;
						this.setCurrentStepAndFailStep();
					}, 10);
				},
			})
			.add(() => {
				this.isLoadingFail = false;
			});
	}

	stepSuccess(): void {
		if (this.isLoadingFail == true || this.isLoadingSuccess == true) return;

		this.isLoadingSuccess = true;
		this.ChecklistExecutionService.stepSuccess(this.checklist.id)
			.subscribe({
				next: (checklist) => {
					this.checklist = undefined;
					this.currentStep = undefined;
					this.currentStepIndex = undefined;
					setTimeout(() => {
						this.checklist = checklist;
						this.setCurrentStepAndFailStep();
					}, 10);
				},
			})
			.add(() => {
				this.isLoadingSuccess = false;
			});
	}

	setCurrentStepAndFailStep(): void {
		this.currentStep = this.checklist.steps.find((step, index) => {
			if (step.status.toUpperCase() == 'RUNNING') {
				this.currentStepIndex = index;
				return true;
			}
		});

		this.lastFailStep = this.checklist.steps.find((step, index) => {
			if (step.status.toUpperCase() == 'FAIL') {
				this.lastFailIndex = index;
				return true;
			}
		});
	}
}
